module.exports = __webpack_public_path__ + "img/holder.6dac0c2b.png";